import { Button } from '@presentation/components';
import { AiOutlineCheck } from 'react-icons/ai';
import * as Styled from './styled';
import type { MtOnBoardingCardProps } from './types';

export const MtOnBoardingCard = (props: MtOnBoardingCardProps) => {
  const { title, icon, text, btnOnClick, btnText, btnDisabled, btnLoading, checked } = props;

  return (
    <Styled.Wrapper clickable={!btnDisabled} onClick={!btnDisabled ? btnOnClick : undefined}>
      <Styled.Row>
        <Styled.Icon>{icon}</Styled.Icon>
        {checked && (
          <Styled.Checked>
            <AiOutlineCheck />
          </Styled.Checked>
        )}
      </Styled.Row>

      <Styled.Title>{title}</Styled.Title>

      <Styled.Text>{text}</Styled.Text>

      <Styled.Button>
        <Button
          onClick={btnOnClick}
          disabled={btnDisabled}
          color="blue"
          size="small"
          loading={btnLoading}
        >
          {btnText}
        </Button>
      </Styled.Button>
    </Styled.Wrapper>
  );
};
